import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";
import type { InviteActorsNodeData } from "@gestionalo/enterprise-graph";

interface Props {
  data: InviteActorsNodeData;
  onChange: (patch: Partial<InviteActorsNodeData>) => void;
}

export function InviteActorsEditor({ data, onChange }: Props): JSX.Element {
  return (
    <div className="space-y-4">
      <div className="space-y-1">
        <Label className="text-sm">Título del paso *</Label>
        <Input
          value={data.label ?? ""}
          onChange={(e) => onChange({ label: e.target.value })}
          placeholder="Invitar participantes"
        />
      </div>
      <div className="space-y-1">
        <Label className="text-sm">Descripción (opcional)</Label>
        <Textarea
          value={data.description ?? ""}
          onChange={(e) => onChange({ description: e.target.value })}
          rows={2}
        />
      </div>
      <div className="space-y-1">
        <Label className="text-sm">Nombre del participante</Label>
        <Input
          value={data.actorLabel ?? ""}
          onChange={(e) => onChange({ actorLabel: e.target.value })}
          placeholder="Participante"
        />
        <p className="text-xs text-muted-foreground">
          Personaliza cómo se llaman los actores (ej: Inquilino, Socio, Titular).
        </p>
      </div>
      <div className="space-y-1">
        <Label className="text-sm">Cantidad máxima de participantes *</Label>
        <Input
          type="number"
          min={2}
          max={10}
          value={data.maxActors ?? 2}
          onChange={(e) =>
            onChange({
              maxActors: Math.max(2, Math.min(10, Number(e.target.value) || 2)),
            })
          }
        />
        <p className="text-xs text-muted-foreground">
          Incluye al participante principal. Ej: 3 = 1 principal + 2 participantes.
        </p>
      </div>
      <div className="space-y-1">
        <Label className="text-sm">Visibilidad del participante</Label>
        <Select
          value={data.participantScope ?? "full"}
          onValueChange={(v) => onChange({ participantScope: v as 'full' | 'limited' })}
        >
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="full">Completa — ve todo el proceso</SelectItem>
            <SelectItem value="limited">Limitada — solo ve sus pasos</SelectItem>
          </SelectContent>
        </Select>
        <p className="text-xs text-muted-foreground">
          Controla qué información ve el participante. "Limitada" oculta datos de la solicitud, precio y actividad.
        </p>
      </div>
    </div>
  );
}
